import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Assignee from 'components/sales/formSection/assignee/assignee';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const ChangeAssignee = ({
  getAssigneeList,
  assigneeList,
  match,
  postAssignee,
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const [leadId, setleadId] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isRequired, setRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const inputs = {
    assigneeDetail: null,
  };
  const [assigneeData, setAssigneeData] = useState(inputs);
  useEffect(() => {
    setleadId(match.params.id);
    (async () => {
      if (leadId) {
        setIsLoading(true);
        await getAssigneeList(leadId);
        setIsLoading(false);
      }
    })();
  }, [leadId]);

  const handleAssignee = (val) => {
    setAssigneeData({ ...assigneeData, assigneeDetail: val });
  };
  const handleModalHide = () => setIsModal(false);
  const handleSubmit = () => {
    const { assigneeDetail } = assigneeData;
    if (assigneeDetail === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      setIsModal(true);
      const res = postAssignee(assigneeDetail);
      if (res) getAssigneeList(leadId);
    }
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.changeAssignee}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
    >
      <Assignee
        assigneeList={assigneeList}
        leadId={leadId}
        handleValue={handleAssignee}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

ChangeAssignee.propTypes = {};

export default ChangeAssignee;
